export default {
  name: "StackBeans",
  date: new Date().getFullYear()
};
